var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7467 7.63335C15.0467 4.55335 12.36 3.16669 10 3.16669C10 3.16669 10 3.16669 9.99333 3.16669C7.64 3.16669 4.94667 4.54669 4.24667 7.62669C3.46667 11.0667 5.57333 13.98 7.48 15.8134C8.18667 16.4934 9.09333 16.8334 10 16.8334C10.9067 16.8334 11.8133 16.4934 12.5133 15.8134C14.42 13.98 16.5267 11.0734 15.7467 7.63335ZM10 10.9734C8.84 10.9734 7.9 10.0334 7.9 8.87335C7.9 7.71335 8.84 6.77335 10 6.77335C11.16 6.77335 12.1 7.71335 12.1 8.87335C12.1 10.0334 11.16 10.9734 10 10.9734Z",
    fill: "#FF66A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationManagement);
export default __webpack_public_path__ + "static/media/location-management.1c5b11f7063e719de3777317c53bbc2f.svg";
export { ForwardRef as ReactComponent };